var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-editor',_vm._b({attrs:{"editor-toolbar":_vm.customToolbar},on:{"input":_vm.onInput},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}},'vue-editor',{ placeholder: _vm.placeholder },false))}
var staticRenderFns = []

export { render, staticRenderFns }